import script from "./sf-modal-message.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-modal-message.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__